import { api } from "@/lib/api";
import { Panel, Table, useLoad, Loading } from "@/components/common";

export default function Audit({ p }) {
  const { data, error } = useLoad(() => api.get(`/projects/${p.id}/audit`).then((r) => r.data), [p.id]);
  if (!data) return <Loading error={error} />;
  return (
    <Panel title="Project audit trail" testid="project-audit">
      <Table rows={data} cols={[{ k: "at", h: "When", r: (a) => new Date(a.at).toLocaleString() }, { k: "actor_name", h: "Actor" }, { k: "action", h: "Action", r: (a) => <code className="text-xs">{a.action}</code> },
        { k: "details", h: "Details", r: (a) => <span className="text-xs text-slate-500">{JSON.stringify(a.details).slice(0, 140)}</span> }]} />
    </Panel>
  );
}
